/*
 * @Date: 2020-07-20 11:53:53
 * @LastEditTime: 2020-07-27 10:18:42
 * @LastEditors: Junfeng.wang
 */
export default {
  fixed: [
    {
      path: '/order/logistics-detail',
      name: 'order-logistics-detail',
      component: () => import(/* webpackChunkName: "order-logistics-detail" */'../routes/order/logistics-detail/index.vue'),
      meta: {
        title: {
          'zh-CN': '物流详情',
          en: '物流详情_en',
          jp: '物流详情_jn'
        },
        spmB: 'b20',
        isNewHeader: true
      }
    },
    {
      path: '/receive-order/edit',
      name: 'order-receive-confirm-order',
      component: () => import(/* webpackChunkName: "order-receive-order-edit-order" */'../routes/order/receive-order/edit/index.vue'),
      meta: {
        title: {
          'zh-CN': '编辑收货单',
          en: '编辑收货单_en',
          jp: '编辑收货单_jn'
        },
        spmB: 'b20',
        isNewHeader: true,
        i18nCode: 'receive-order-detail',
        menuCode: '/receive-order'
      }
    },
    {
      path: '/receive-order/create',
      name: 'order-receive-confirm-order',
      component: () => import(/* webpackChunkName: "order-receive-order-create-order" */'../routes/order/receive-order/create/index.vue'),
      meta: {
        title: {
          'zh-CN': '确认收货',
          en: '确认收货_en',
          jp: '确认收货_jn'
        },
        spmB: 'b20',
        isNewHeader: true,
        menuCode: '/order/list',
        i18nCode: 'confirm-order'
      }
    },
    {
      path: '/receive-order/detail',
      name: 'receive-order-detail',
      component: () => import(/* webpackChunkName: "order-receive-order-detail" */'../routes/order/receive-order/detail/_index.vue'),
      meta: {
        title: {
          'zh-CN': '收货单详情',
          en: '收货单详情_en',
          jp: '收货单详情_jn'
        },
        spmB: 'b20',
        isNewHeader: true,
        menuCode: '/order/receive',
        i18nCode: 'receive-order-detail'
      }
    },
    {
      path: '/return-order/create',
      name: 'return-order-create',
      component: () => import(/* webpackChunkName: "order-return-order-create" */'../routes/order/return-order/create/index.vue'),
      meta: {
        title: {
          'zh-CN': '创建退货单',
          en: '创建退货单_en',
          jp: '创建退货单_jn'
        },
        spmB: 'b20',
        menuCode: '/order/receive',
        isNewHeader: true,
        i18nCode: 'order-return-order-create'
      }
    },
    {
      path: '/return-order/detail',
      name: 'return-order-detail',
      component: () => import(/* webpackChunkName: "order-return-order-detail" */'../routes/order/return-order/detail/index.vue'),
      meta: {
        title: {
          'zh-CN': '退货单详情',
          en: '退货单详情_en',
          jp: '退货单详情_jn'
        },
        spmB: 'b20',
        menuCode: '/return-order',
        isNewHeader: true,
        i18nCode: 'order-return-order-detail'
      }
    },
    {
      path: '/return-order/edit',
      name: 'return-order-edit',
      component: () => import(/* webpackChunkName: "order-return-order-detail" */'../routes/order/return-order/edit/index.vue'),
      meta: {
        title: {
          'zh-CN': '编辑退货单',
          en: '编辑退货单_en',
          jp: '编辑退货单_jn'
        },
        spmB: 'b20',
        i18nCode: 'order-return-order-create',
        menuCode: '/return-order',
        isNewHeader: true
      }
    },
    // 订单详情
    {
      name: 'order-details',
      path: '/order-details',
      component: () => import(/* webpackChunkName: "order-details" */'../routes/order/order/detail/index.vue'),
      meta: {
        title: {
          'zh-CN': '订单详情',
          en: '订单详情_en',
          jp: '订单详情_jp'
        },
        spmB: 'b5',
        isNewHeader: true,
        menuCode: '/order/list'
      }
    }
  ],
  fluid: [
    // 我的订单
    {
      path: '/order/list',
      name: 'my-order',
      component: () => import(/* webpackChunkName: "my-order" */'../routes/order/order/list/index.vue'),
      meta: {
        title: {
          'zh-CN': '我的订单',
          en: '我的订单_en',
          jp: '我的订单_jn'
        },
        spmB: 'b21',
        isNewHeader: true
      }
    },
    // 我的收货单
    {
      path: '/receive-order',
      name: 'receive-order',
      component: () => import(/* webpackChunkName: "order-receive-order" */'../routes/order/receive-order/list/index.vue'),
      meta: {
        title: {
          'zh-CN': '我的收货单',
          en: '我的收货单_en',
          jp: '我的收货单_jn'
        },
        spmB: 'b21',
        isNewHeader: true
      }
    },
    // 我的退货单
    {
      path: '/return-order',
      name: 'return-order',
      component: () => import(/* webpackChunkName: "order-return-order" */'../routes/order/return-order/list/index.vue'),
      meta: {
        title: {
          'zh-CN': '我的退货单',
          en: '我的退货单_en',
          jp: '我的退货单_jn'
        },
        spmB: 'b22',
        isNewHeader: true
      }
    }
  ]
}
